export const normalizeItem = <T>(query: { node: T }): T => query.node

export const normalizeArray = <T>(query: { edges: { node: T }[] }): T[] =>
  query.edges.map(normalizeItem)
